import React, { Fragment } from "react";
import styles from "./index.module.css";
import { joinClass } from "../../helpers/utils";
import { MdDone } from "react-icons/md";
import { useTranslation } from "react-i18next";

const ProgressBar = ({ data, activeStep }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.progress_bar}>
      <section className={styles["progress_bar__data"]}>
        {data?.map((item, key) => (
          <Fragment key={key}>
            <div className={styles["progress_bar__data-items"]}>
              <span
                className={joinClass(
                  styles["progress_bar__data-container"],
                  item?.active && styles["progress_bar__data-container-active"]
                )}
              >
                {key < activeStep ? (
                  <MdDone size={20} color="#44793F" />
                ) : (
                  item?.id
                )}
              </span>
              <label
                className={joinClass(
                  styles["progress_bar__data-container-label"]
                )}
              >
                {t(item?.name)}
              </label>
            </div>
            {key < data.length - 1 && (
              <span
                className={styles["progress_bar__data-container-line"]}
              ></span>
            )}
          </Fragment>
        ))}
      </section>
      {/* <span></span> */}
    </div>
  );
};

export default ProgressBar;
